export class RfqMaxAmounts {
  maxSellAmount: bigint;
  maxBuyAmount: bigint;
  maxValueInUsd: number;
}
